<template lang="html">
  	<div class="activityListContainer">
  		<div class="searchBox">
			<input type="search" name="searchActivity" id="search"  placeholder="搜索" @keyup="inputSearch($event)"/>
			<img src="../../assets/img/ic_search.png" />
		</div>
		<div class="tagContainer">
			<div class="title">标签</div>
			<div class="list">
				<div class="tagBtn" v-for="(item,index) in tagArr" v-on:click="tagSearch(index,item,$event)">{{item}}</div>
				<!-- <div class="tagBtn activediv">鸿鹄投资课</div> -->
			</div>
		</div>
		<div class="activityList" id="pullrefresh">
			<div class="listContainer">
				<div class="container"  v-for="(item,index) in allListArray" v-on:click="toDetailInfo(index)">
					<router-link :to="{ name:'activityDetail',params: { infoId: item.INFO_ID},query: { typeCode: typeCode }}">
						<div class="imgContainer">
							<img v-bind:src="imgSrc+item.PIC_PATH" />
							<!-- <img src="../../assets/img/index-exchange.png" /> -->
							<div class="activityColumn">{{item.TYPE_NAME}}</div>
						</div>
						<div class="textContainer">
							<div class="text-title">{{item.TITLE}}</div>
							<div class="text-content">{{item.ABSTRACT}}</div>
						</div>
						<div class="line"></div>
					</router-link>
				</div>
			</div>
			<div class="loading" v-show="loadingIndex"><img src="../../assets/img/loading.gif" /><span>{{loadingTxt}}</span></div>
		</div>
    </div>
</template>
<script>
	import Server from '../../server/server.js'
	import {alertMsg,alertAndFunc,commonPicUrl} from '../../common/url.js';
	import $ from 'jquery';
	export default {
	  	name: 'activityListContainer',
	  	data(){
		  	return{
		  		imgSrc:commonPicUrl,
		  		allListArray:[],
		  		startIndex:0,
		  		endIndex:5,
		  		pageLength:6,
		  		typeCode:'9902001|9902002|9902003|9902004|9902005',
		  		page:0,
		  		loadingIndex:true,   //滚动是否加载数据
		  		timer:null,
		  		loadingTxt:'正在加载中 ...',
		  		loadingTimer:null,
		  		tagName:'',          //标签搜索内容
		  		searchTxt:'',        //input 搜索内容
		  	}
	  	},
	  	props:['tagArr'],
	  	methods:{
	  		//专属周边数据
	  		getInfo:function(page){
	  			let startIndex = page+this.startIndex;
	  			let endIndex = page+this.endIndex;
	  			let array=[];
	  			Server.listInfo(startIndex,endIndex,this.typeCode,this.tagName,this.searchTxt).then((result)=>{
		  			if(result.code == '0'){
		  				console.log(this.loadingIndex);
		  				console.log(result.msg.infos);
		  				if(result.msg.infos.length>0){
		  					this.allListArray = this.allListArray.concat(result.msg.infos);
		  					if(result.msg.infos.length < this.pageLength){
		  						this.loadingTxt = '没有更多内容了';
		  						let that = this;
			  					clearTimeout(that.loadingTimer);
				        		that.loadingTimer=setTimeout(function () {
					                that.loadingIndex = false;	
					                console.log(that.loadingIndex);
					           	},50);
		  					}
		  				}else{
		  					if(this.searchTxt || this.tagName){
		  						this.mui.alert('暂时没有您搜索的内容！',' ', function() {
		  							window.location.reload();
		  						});
		  					}
		  					let that = this;
		  					clearTimeout(that.loadingTimer);
			        		that.loadingTimer=setTimeout(function () {
				                that.loadingIndex = !that.loadingIndex;	
				                console.log(that.loadingIndex);
				           	},50);
		  					
		  				}	
		  			}
		  		})
	  		},
	  		//input搜索
	  		inputSearch:function(event){
	  			if(event.keyCode=="13"){
	  				let searchTxt = event.target.value;
	  				if(searchTxt == ''){
	  					alertMsg('搜索内容不能为空');
	  					return
	  				}else{
	  					this.searchTxt = $.trim(event.target.value);
	  				}
	  				this.page = 0;
	  				this.allListArray = [];
	  				this.getInfo(this.page);
	  			}
	  		},
	  		//tag搜索
	  		tagSearch:function(index,item,event){
	  			let clickBtn = event.target;
	  			let btnFather = clickBtn.parentNode;
	  			if(btnFather.querySelector('.activediv')){
	  				btnFather.querySelector('.activediv').classList.remove('activediv');  //去除hover状态的元素样式
	  			}
	  			clickBtn.setAttribute("class",clickBtn.getAttribute("class")+" "+'activediv');  //为当前元素添加hover状态
	  			this.tagName = $.trim(item);
	  			this.page = 0;
	  			this.allListArray = [];
	  			this.getInfo(this.page);
	  		},
	  		//跳转资讯详情
	  		toDetailInfo:function(index){
	  			let sequence = parseInt(index);
	  			localStorage.setItem('activitySequence',sequence);
	  		}
	  	},
	  	created(){
	  		//专属周边数据
	  		this.getInfo(this.page);
	  	},
	  	mounted(){
	  		let that = this;
	  		$('.activityList').scroll(function(){
		        var contentHeight = $('.activityList').height(),
		            contentScroll = $('.activityList').scrollTop(),
		            contentScrollHeight = document.getElementById("pullrefresh").scrollHeight;
		        if(that.loadingIndex){
		        	if(contentHeight+contentScroll+20>=contentScrollHeight){
		        		clearTimeout(that.timer);
		        		that.timer=setTimeout(function () {
			                that.page = that.page +that.pageLength;
			            	that.getInfo(that.page);
			           },500);
			        }
		        }
		        
		    })
	  	}
	}
</script>
<style lang="less" scoped>
	.activityListContainer{
		width:100%;
		padding:0 40px;
		.searchBox{
			margin-top:40px;
			width:100%;
			position: relative;
			input{
				border:2px solid #e5e5e5;
				border-radius:8px;
				width:100%;
				height:100px;
				line-height:100px;
				padding-left: 30px;
				font-size:28px;
				color:#818181;
				letter-spacing:0;
				text-align:left;
				outline: none;
			}
			img{
				position: absolute;
				right:40px;
				top:35px;
			}
		}
		.tagContainer{
			margin-top:40px;
			width:100%;
			.title{
				font-size:28px;
				color:#ad8f5a;
				letter-spacing:1.4px;
				height:52px;
				line-height:52px;
				text-align:left;
				font-weight: bold;
			}
			.list{
				display: inline-block;
				.tagBtn{
					border:2px solid #e5e5e5;
					border-radius:8px;
					height:60px;
					line-height:56px;
					float:left;
					padding-left:30px;
					padding-right: 30px;
					margin-top: 20px;
					margin-right: 20px;
					font-size:24px;
					color:#818181;
					letter-spacing:0.12px;
					background-color: #ffffff;
				}
				.activediv{
					color:#ffffff;
					background-color: #ad8f5a;
				}
			}
		}
		.activityList{
			width:100%;
			height:800px;
			overflow:scroll;
			.container{
				width:100%;
				margin-top:40px;
				display:inline-block;
				.imgContainer{
					float:left;
					width:30%;
					position:relative;
					img{
						width:100%;
						max-height:200px;
					}
					.activityColumn{
						position:absolute;
						bottom:0;
						width:100%;
						opacity:0.7;
						background:#ad8f5a;
						height:40px;
						line-height:40px;
						text-align:center;
						font-size:20px;
						color:#ffffff;
					}
				}
				.textContainer{
					float:right;
					width:70%;
					padding-left:20px;
					text-align:left;
					.text-title{
						font-size:28px;
						color:#333333;
						letter-spacing:0;
						line-height:40px;
						height:40px;
						text-overflow:ellipsis;
						overflow: hidden;
				    	display: -webkit-box;
		    			-webkit-line-clamp: 1;
		    			-webkit-box-orient: vertical;
		    			word-break:break-all;
		    			-webkit-box-orient: vertical;
		    			font-weight:bold;
					}
					.text-content{
						margin-top:5px;
						font-size:24px;
						color:#666666;
						letter-spacing:0.08px;
						line-height:40px;
						height:160px;
						overflow: hidden;
				    	display: -webkit-box;
		    			-webkit-line-clamp: 4;
		    			-webkit-box-orient: vertical;
		    			word-break:break-all;
		    			-webkit-box-orient: vertical;
					}
				}
				.line{
					margin-top:30px;
					float:left;
					width:100%;
					background:#d8d8d8;
					height:2px;
				}
			}
		}
		.loading{
			width:100%;
			height:40px;
			text-align:center;
			line-height:40px;
			margin-top:20px;
			img{
				vertical-align:middle;
				width:40px;
			}
			span{
				padding-left:10px;
				font-size:26px;
				color:#666666;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/activity/activityList.vue